<div class="einstallen-tiere-hinzufuegen-root">
    <kiene-mobile-page-header *ngIf="!hideMobileHeader" [ueberschrift]="'Einstallen'"></kiene-mobile-page-header>

    <div class="einstallen-tiere-hinzufuegen-content">
    <h4 *ngIf="!hideMobileHeader" class="einstallen-gruppe-title">Gruppe: {{ gruppe?.bezeichnung }}</h4>

    <ng-template #einstallenHerkunftSection>
        <section class="einstallen-pass-section einstallen-pass-section--optional einstallen-herkunft-section">
            <div class="einstallen-pass-section__header">
                <h4 class="einstallen-pass-section__title">Herkunft</h4>
                <p class="einstallen-pass-section__hint">Optional: Kontakt oder H&auml;ndler zuordnen.</p>
            </div>

            <div class="einstallen-pass-source-switch">
                <button
                    type="button"
                    mat-stroked-button
                    class="einstallen-pass-source-switch__button"
                    [class.einstallen-pass-source-switch__button--active]="passSourceMode === 'none'"
                    (click)="setPassSourceMode('none')"
                >
                    Keine Herkunft
                </button>
                <button
                    type="button"
                    mat-stroked-button
                    class="einstallen-pass-source-switch__button"
                    [class.einstallen-pass-source-switch__button--active]="passSourceMode === 'haendler'"
                    (click)="setPassSourceMode('haendler')"
                >
                    H&auml;ndler
                </button>
                <button
                    *kienePermission="[9601]"
                    type="button"
                    mat-stroked-button
                    class="einstallen-pass-source-switch__button"
                    [class.einstallen-pass-source-switch__button--active]="passSourceMode === 'kontakt'"
                    (click)="setPassSourceMode('kontakt')"
                >
                    Kontakt
                </button>
            </div>

            <div class="einstallen-pass-source-panel" *ngIf="passSourceMode === 'haendler'">
                <div
                    *ngIf="haendlerFavoritenLoading"
                    class="einstallen-empty-state einstallen-empty-state--compact"
                    data-cy="einstallen-haendler-loading"
                >
                    <p class="einstallen-empty-state__hint">H&auml;ndler werden geladen&hellip;</p>
                </div>

                <div
                    *ngIf="showHaendlerFavoritenEmptyState"
                    class="einstallen-empty-state"
                    data-cy="einstallen-haendler-empty"
                >
                    <mat-icon>storefront</mat-icon>
                    <p class="einstallen-empty-state__title">Keine H&auml;ndler hinterlegt</p>
                    <p class="einstallen-empty-state__hint">
                        Legen Sie Favoriten-H&auml;ndler an, um sie beim Einstallen schnell zuzuordnen.
                    </p>
                    <button
                        *ngIf="canEditHaendler"
                        mat-stroked-button
                        color="accent"
                        type="button"
                        data-cy="einstallen-haendler-empty-add"
                        (click)="openHaendlerVerwaltung()"
                    >
                        H&auml;ndler anlegen
                    </button>
                </div>

                <div class="einstallen-pass-source-panel__row" *ngIf="!haendlerFavoritenLoading && haendlerFavoriten.length > 0">
                    <mat-form-field class="einstallen-pass-field">
                        <mat-label>H&auml;ndler ausw&auml;hlen</mat-label>
                        <mat-select
                            [disabled]="isLoading"
                            data-cy="einstallen-pass-haendler-select"
                            [compareWith]="compareHaendler"
                            [formControl]="haendlerCtrl"
                        >
                            <mat-option [value]="null"> - kein H&auml;ndler - </mat-option>
                            <mat-option *ngFor="let haendler of haendlerFavoriten" [value]="haendler">
                                {{ haendler.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <button
                        *kienePermission="[9132]"
                        data-cy="einstallen-pass-haendler-add"
                        (click)="openHaendlerVerwaltung()"
                        mat-icon-button
                        color="accent"
                        [disabled]="!canEditHaendler"
                        type="button"
                    >
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            </div>

            <div class="einstallen-pass-source-panel" *ngIf="passSourceMode === 'kontakt'">
                <ng-container *kienePermission="[9601]">
                    <div *ngIf="selectedBetriebskontakte.length > 0">
                        <kiene-betriebskontakt-card
                            [kontakt]="selectedBetriebskontakte[0]"
                            [config]="{
                                showActions: true,
                                showMenu: false,
                                showFavorit: false,
                                showBadge: true,
                                compact: false,
                                selectedMode: true
                            }"
                            (entfernen)="onBetriebskontaktEntfernen()"
                        >
                        </kiene-betriebskontakt-card>
                    </div>

                    <div *ngIf="selectedBetriebskontakte.length === 0">
                        <kiene-betriebskontakt-auswahl
                            [config]="betriebskontaktConfig"
                            [selectedKontakte]="selectedBetriebskontakte"
                            (kontaktSelected)="onBetriebskontaktSelected($event)"
                            (kontakteSelected)="onBetriebskontakteSelected($event)"
                        >
                        </kiene-betriebskontakt-auswahl>
                    </div>
                </ng-container>
            </div>
        </section>
    </ng-template>

    <div *ngIf="showPassFeatures" class="einstallen-pass-layout">
        <section class="einstallen-pass-row">
            <div
                class="einstallen-pass-section einstallen-pass-section--primary"
                [class.einstallen-pass-section--einstalldatum-highlighted]="einstalldatumHintHighlighted"
            >
                <div class="einstallen-pass-section__header">
                    <h4 class="einstallen-pass-section__title">Einstalldatum</h4>
                    <p class="einstallen-pass-section__hint" *ngIf="datumCtrl.value">
                        Optional &ndash; kann auch sp&auml;ter gesetzt werden.
                    </p>
                    <div
                        *ngIf="isEinstalldatumMissingForScan"
                        class="einstallen-einstalldatum-required-hint einstallen-einstalldatum-required-hint--compact"
                        data-cy="einstallen-einstalldatum-required-hint-card"
                        role="status"
                    >
                        <mat-icon class="einstallen-einstalldatum-required-hint__icon" aria-hidden="true">info</mat-icon>
                        <span>Bitte ein Einstalldatum w&auml;hlen, bevor Sie Tiere hinzuf&uuml;gen.</span>
                    </div>
                </div>

                <mat-form-field class="einstallen-pass-field">
                    <mat-label>Einstalldatum</mat-label>
                    <input
                        [disabled]="isLoading"
                        data-cy="einstallen-einstalldatum"
                        matInput
                        [matDatepicker]="picker"
                        [readonly]="true"
                        [formControl]="datumCtrl"
                    />
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            </div>

            <div class="einstallen-pass-section einstallen-pass-section--optional">
                <div class="einstallen-pass-section__header">
                    <h4 class="einstallen-pass-section__title">Bemerkung</h4>
                    <p class="einstallen-pass-section__hint">Optional</p>
                </div>

                <mat-form-field class="no-padding-margin-mat-form-field einstallen-pass-field">
                    <mat-label>Bemerkung</mat-label>
                    <input [disabled]="isLoading" data-cy="einstallen-bemerkung" matInput [formControl]="bemerkungCtrl" />
                </mat-form-field>
            </div>
        </section>

        <ng-container *ngTemplateOutlet="einstallenHerkunftSection"></ng-container>
    </div>

    <section
        *ngIf="!showPassFeatures"
        class="einstallen-pass-section einstallen-pass-section--primary einstallen-mobile-einstalldatum"
        [class.einstallen-mobile-einstalldatum--empty]="!datumCtrl.value"
        [class.einstallen-mobile-einstalldatum--highlighted]="einstalldatumHintHighlighted"
    >
        <div class="einstallen-pass-section__header">
            <h4 class="einstallen-pass-section__title">Einstalldatum</h4>
            <p class="einstallen-pass-section__hint">Optional &ndash; kann auch sp&auml;ter gesetzt werden.</p>
        </div>

        <mat-form-field class="einstallen-pass-field einstallen-mobile-einstalldatum__field" appearance="outline">
            <mat-label>Datum w&auml;hlen</mat-label>
            <input
                [disabled]="isLoading"
                data-cy="einstallen-einstalldatum"
                matInput
                [matDatepicker]="pickerMobile"
                [readonly]="true"
                [formControl]="datumCtrl"
            />
            <mat-datepicker-toggle matSuffix [for]="pickerMobile"></mat-datepicker-toggle>
            <mat-datepicker #pickerMobile></mat-datepicker>
        </mat-form-field>
    </section>

    <ng-container *ngIf="!showPassFeatures">
        <ng-container *ngTemplateOutlet="einstallenHerkunftSection"></ng-container>
    </ng-container>

    <div class="einstallen-abteil-row">
        <mat-form-field class="einstallen-abteil-row__field no-padding-margin-mat-form-field">
            <mat-label>Abteil</mat-label>
            <input [disabled]="isLoading" data-cy="einstallen-abteil" matInput [formControl]="abteilCtrl" />
            <button mat-icon-button matSuffix [disabled]="abteilCtrl.value === null" (click)="abteilCtrl.setValue(null)">
                <mat-icon>clear</mat-icon>
            </button>
        </mat-form-field>
        <div class="einstallen-abteil-row__transponder">
            <mat-slide-toggle
                data-cy="einstallen-transpondernummer-toggle"
                [disabled]="isLoading"
                [formControl]="mitTransponderNummerToggleCtrl"
            ></mat-slide-toggle>
            <span class="einstallen-abteil-row__transponder-label" (click)="changeTransponderNrToggle($event)">
                mit Transpondernr.
            </span>
        </div>
    </div>

    <section class="einstallen-pass-section einstallen-pass-section--scan">
        <div class="einstallen-pass-section__header">
            <h4 class="einstallen-pass-section__title">Tiere hinzuf&uuml;gen</h4>
            <div class="einstallen-pass-method-switch" *ngIf="showPassFeatures">
                <button
                    type="button"
                    mat-stroked-button
                    class="einstallen-pass-method-switch__button"
                    [class.einstallen-pass-method-switch__button--active]="passInputMode === 'scan'"
                    (click)="setPassInputMode('scan')"
                >
                    Scan
                </button>
                <button
                    type="button"
                    mat-stroked-button
                    class="einstallen-pass-method-switch__button"
                    [class.einstallen-pass-method-switch__button--active]="passInputMode === 'excel'"
                    (click)="setPassInputMode('excel')"
                >
                    Excel
                </button>
                <button
                    type="button"
                    mat-stroked-button
                    class="einstallen-pass-method-switch__button"
                    [class.einstallen-pass-method-switch__button--active]="passInputMode === 'pdf'"
                    (click)="setPassInputMode('pdf')"
                >
                    PDF
                </button>
            </div>
            <p class="einstallen-pass-section__hint" *ngIf="passInputMode === 'scan'">
                Ohrmarke (10 Zeichen) oder Pass (15 Zeichen) scannen — wird automatisch erkannt.
            </p>
            <div
                *ngIf="isEinstalldatumMissingForScan"
                class="einstallen-einstalldatum-required-hint"
                data-cy="einstallen-einstalldatum-required-hint"
                role="status"
            >
                <mat-icon class="einstallen-einstalldatum-required-hint__icon" aria-hidden="true">info</mat-icon>
                <span>{{ einstalldatumRequiredHintText }}</span>
            </div>
            <p class="einstallen-pass-section__hint" *ngIf="passInputMode === 'excel'">
                Excel-Liste importieren, um mehrere Tiere auf einmal hinzuzuf&uuml;gen.
            </p>
            <p class="einstallen-pass-section__hint" *ngIf="passInputMode === 'pdf'">
                Rinderpass-PDF importieren und im Hintergrund verarbeiten lassen.
            </p>
        </div>

        <div
            class="one-row einstallen-pass-scan-field-wrap"
            *ngIf="passInputMode === 'scan'"
            [class.einstallen-pass-scan-field-wrap--disabled]="isScanInputDisabled"
            (click)="onDisabledScanFieldClick()"
        >
            <mat-form-field
                class="no-padding-margin-mat-form-field einstallen-pass-field einstallen-pass-field--scan"
                [class.einstallen-pass-field--disabled]="isScanInputDisabled"
            >
                <mat-label>Ohrmarke / Pass scannen</mat-label>

                <input
                    [disabled]="isScanInputDisabled"
                    [readonly]="isScanInputDisabled"
                    data-cy="einstallen-ohrmarke-pass-input"
                    type="text"
                    maxlength="{{ maxLengthOhrmarke }}"
                    #ohrenmarkeInput="matInput"
                    matInput
                    [formControl]="ohrenmarkeCtrl"
                    (keyup.enter)="onScanEnter($event)"
                />
                <span matSuffix class="einstallen-pass-field__counter">
                    {{ ohrenmarkeCtrl.value?.length }}/{{ maxLengthOhrmarke }}
                </span>

                <button
                    *ngIf="canSubmitScan"
                    data-cy="einstallen-add-ohrmarke-pass"
                    matSuffix
                    mat-icon-button
                    [disabled]="isScanInputDisabled"
                    (click)="addOhrmarke()"
                >
                    <mat-icon>check</mat-icon>
                </button>
            </mat-form-field>
        </div>

        <div
            class="einstallen-upload-box"
            *ngIf="showPassFeatures && passInputMode === 'excel'"
            [class.einstallen-upload-box--disabled]="isEinstalldatumMissingForScan"
            (click)="onDisabledUploadClick()"
        >
            <div class="einstallen-upload-box__row">
                <button
                    type="button"
                    mat-flat-button
                    color="accent"
                    [disabled]="!datumCtrl.value || excelUploadInProgress"
                    (click)="openPassExcelFileSelector()"
                >
                    <mat-icon>{{ excelUploadInProgress ? 'hourglass_top' : 'attach_file' }}</mat-icon>
                    {{ excelUploadInProgress ? 'Lade hoch...' : 'Excel importieren' }}
                </button>
                <button
                    type="button"
                    mat-icon-button
                    class="einstallen-excel-format-hint-toggle"
                    data-cy="einstallen-excel-format-hint-toggle"
                    aria-label="Beispielaufbau der Excel-Tierliste anzeigen"
                    matTooltip="Beispielaufbau der Excel-Tierliste"
                    [class.einstallen-excel-format-hint-toggle--active]="excelFormatHintVisible"
                    (click)="toggleExcelFormatHint($event)"
                >
                    <mat-icon>info</mat-icon>
                </button>
            </div>
            <div
                class="einstallen-excel-format-hint"
                *ngIf="excelFormatHintVisible"
                data-cy="einstallen-excel-format-hint"
            >
                <p class="einstallen-excel-format-hint__title">Beispielaufbau der Excel-Tierliste:</p>
                <div class="einstallen-excel-format-hint__box">
                    <mat-icon class="einstallen-excel-format-hint__icon">info</mat-icon>
                    <table class="einstallen-excel-format-hint__table">
                        <tr>
                            <td class="einstallen-excel-format-hint__text-col"></td>
                            <td class="einstallen-excel-format-hint__row-head einstallen-excel-format-hint__row-head--empty"></td>
                            <td class="einstallen-excel-format-hint__col-head">A</td>
                            <td class="einstallen-excel-format-hint__row-head einstallen-excel-format-hint__row-head--trail"></td>
                        </tr>
                        <tr>
                            <td class="einstallen-excel-format-hint__text-col"
                                ><strong>Zeile 1</strong>: Reserviert f&uuml;r &Uuml;berschrift</td
                            >
                            <td class="einstallen-excel-format-hint__row-head">1</td>
                            <td class="einstallen-excel-format-hint__cell"><strong>Ohrmarke</strong></td>
                            <td class="einstallen-excel-format-hint__cell einstallen-excel-format-hint__cell--trail"></td>
                        </tr>
                        <tr>
                            <td class="einstallen-excel-format-hint__text-col"
                                ><strong>Ab Zeile 2</strong>: in Spalte A Ohrmarke eintragen</td
                            >
                            <td class="einstallen-excel-format-hint__row-head">2</td>
                            <td class="einstallen-excel-format-hint__cell">276000362853465</td>
                            <td class="einstallen-excel-format-hint__cell einstallen-excel-format-hint__cell--trail"></td>
                        </tr>
                        <tr>
                            <td class="einstallen-excel-format-hint__text-col einstallen-excel-format-hint__text-col--italic"
                                >Ohrmarke als 15-, 12- oder 10-stelliges Format eintragen</td
                            >
                            <td class="einstallen-excel-format-hint__row-head">3</td>
                            <td class="einstallen-excel-format-hint__cell">0363200490</td>
                            <td class="einstallen-excel-format-hint__cell einstallen-excel-format-hint__cell--trail"></td>
                        </tr>
                        <tr>
                            <td class="einstallen-excel-format-hint__text-col"></td>
                            <td class="einstallen-excel-format-hint__row-head">3</td>
                            <td class="einstallen-excel-format-hint__cell">DE0363394527</td>
                            <td class="einstallen-excel-format-hint__cell einstallen-excel-format-hint__cell--trail"></td>
                        </tr>
                    </table>
                </div>
            </div>
            <input
                #passExcelFileInput
                type="file"
                style="display: none"
                accept=".csv,.xls,.xlsx"
                (change)="onPassExcelFileSelected($event)"
            />
        </div>

        <div
            class="einstallen-upload-box"
            *ngIf="showPassFeatures && passInputMode === 'pdf'"
            [class.einstallen-upload-box--disabled]="isEinstalldatumMissingForScan"
            (click)="onDisabledUploadClick()"
        >
            <button
                type="button"
                mat-flat-button
                color="accent"
                [disabled]="!datumCtrl.value"
                (click)="openPassPdfImportDialog()"
            >
                <mat-icon>picture_as_pdf</mat-icon>
                PDF importieren
            </button>
        </div>
    </section>

    <kiene-gruppe-tier-pass-scan-verwaltung
        *ngIf="showPassFeatures && gruppe && passInputMode === 'pdf'"
        #passPdfVerwaltung
        data-cy="einstallen-pass-pdf-uploads"
        [gruppe]="gruppe"
        [einstallTierlisteId]="currentEinstallTierlisteId"
        [embedded]="true"
        [hideWhenEmpty]="true"
        (tiereUpdated)="onPassPdfTiereUpdated()"
    ></kiene-gruppe-tier-pass-scan-verwaltung>

    <div id="gescannteOhrenmarken" data-cy="einstallen-scan-list" class="einstallen-scan-list">
        <div class="one-row einstallen-scan-list__header">
            <div class="einstallen-scan-list__title-group">
                <h3>Letzte Scans</h3>
                <div class="einstallen-scan-list__stats">
                    <div class="einstallen-scan-list__stat" data-cy="einstallen-tiere-gesamt">
                        <span class="einstallen-scan-list__stat-label">
                            <span class="einstallen-scan-list__stat-label-text einstallen-scan-list__stat-label-text--desktop"
                                >Tiere gesamt</span
                            >
                            <span class="einstallen-scan-list__stat-label-text einstallen-scan-list__stat-label-text--mobile"
                                >Tiere</span
                            >
                        </span>
                        <span class="einstallen-scan-list__stat-value">{{ tiereGesamtDisplay }}</span>
                    </div>
                    <div class="einstallen-scan-list__stat" data-cy="einstallen-akt-abteil">
                        <span class="einstallen-scan-list__stat-label">
                            <span class="einstallen-scan-list__stat-label-text einstallen-scan-list__stat-label-text--desktop"
                                >Akt. Abteil</span
                            >
                            <span class="einstallen-scan-list__stat-label-text einstallen-scan-list__stat-label-text--mobile"
                                >Abteil</span
                            >
                        </span>
                        <span class="einstallen-scan-list__stat-value">{{ aktAbteilDisplay }}</span>
                    </div>
                    <div class="einstallen-scan-list__stat" data-cy="einstallen-pass-gescannt">
                        <span class="einstallen-scan-list__stat-label">
                            <span class="einstallen-scan-list__stat-label-text einstallen-scan-list__stat-label-text--desktop"
                                >Pass</span
                            >
                            <span class="einstallen-scan-list__stat-label-text einstallen-scan-list__stat-label-text--mobile"
                                >Pass</span
                            >
                        </span>
                        <span class="einstallen-scan-list__stat-value">{{ passGescanntDisplay }}</span>
                    </div>
                    <div class="einstallen-scan-list__stat" data-cy="einstallen-ohrmarke-gescannt">
                        <span class="einstallen-scan-list__stat-label">
                            <span class="einstallen-scan-list__stat-label-text einstallen-scan-list__stat-label-text--desktop"
                                >Ohrmarke</span
                            >
                            <span class="einstallen-scan-list__stat-label-text einstallen-scan-list__stat-label-text--mobile"
                                >Ohrm.</span
                            >
                        </span>
                        <span class="einstallen-scan-list__stat-value">{{ ohrmarkeGescanntDisplay }}</span>
                    </div>
                </div>
            </div>
            <div class="einstallen-scan-list__pagination" *ngIf="gescannteOhrmarken?.length > scansPerPage">
                <button mat-icon-button type="button" (click)="previousScansPage()" [disabled]="scansPageIndex === 0">
                    <mat-icon>chevron_left</mat-icon>
                </button>
                <span>Seite {{ scansPageIndex + 1 }} / {{ scansTotalPages }}</span>
                <button
                    mat-icon-button
                    type="button"
                    (click)="nextScansPage()"
                    [disabled]="scansPageIndex >= scansTotalPages - 1"
                >
                    <mat-icon>chevron_right</mat-icon>
                </button>
            </div>
            <!--<p>{{timeMs ? (timeMs + 'ms') : ''}}</p>-->
        </div>
        <div
            *ngIf="isLastScansHerkunftFilterActive"
            class="einstallen-scan-list__filter-banner"
            data-cy="einstallen-scan-list-herkunft-filter"
        >
            <span class="einstallen-scan-list__filter-banner-text">
                <span class="einstallen-scan-list__filter-label">Herkunft:</span>
                <span class="einstallen-scan-list__filter-value" [title]="lastScansHerkunftFilterLabel">{{
                    lastScansHerkunftFilterLabel
                }}</span>
                <span class="einstallen-scan-list__filter-count" data-cy="einstallen-herkunft-tiere"
                    >{{ herkunftTiereCountLabel }}</span
                >
            </span>
            <button
                type="button"
                mat-icon-button
                class="einstallen-scan-list__filter-clear"
                data-cy="einstallen-scan-list-herkunft-filter-clear"
                aria-label="Herkunft zur&uuml;cksetzen und alle Tiere anzeigen"
                matTooltip="H&auml;ndler/Kontakt zur&uuml;cksetzen und alle Tiere anzeigen"
                (click)="clearLastScansHerkunftFilter()"
            >
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <div
            *ngIf="gescannteOhrmarken?.length < 1"
            class="einstallen-empty-state einstallen-empty-state--scans"
            data-cy="einstallen-scans-empty"
        >
            <mat-icon>qr_code_scanner</mat-icon>
            <p class="einstallen-empty-state__title">Noch keine Scans</p>
            <p class="einstallen-empty-state__hint">{{ lastScansEmptyHint }}</p>
        </div>
        <ul *ngIf="pagedScans?.length > 0" class="einstallen-scan-rows" [class.einstallen-scan-rows--mobile]="hideMobileHeader">
            <li class="einstallen-scan-row einstallen-scan-row--head" aria-hidden="true">
                <span class="einstallen-scan-row__status"></span>
                <span class="einstallen-scan-row__col-head">Ohrmarke</span>
                <span *ngIf="!hideMobileHeader" class="einstallen-scan-row__col-head">Abteil</span>
                <span *ngIf="!hideMobileHeader" class="einstallen-scan-row__col-head">Herkunft</span>
                <span class="einstallen-scan-row__col-head einstallen-scan-row__col-head--gewicht">Gewicht</span>
                <span class="einstallen-scan-row__actions-head"></span>
            </li>
            <li
                *ngFor="let scan of pagedScans; let i = index"
                class="einstallen-scan-row"
                [@openClose]="i === 0 ? openCloseState : 'closed'"
                [attr.data-cy]="'einstallen-scan-row-' + i"
            >
                <mat-icon
                    class="einstallen-scan-row__status"
                    [style.color]="getScanStatusColor(scan)"
                    [title]="getScanStatusTooltip(scan)"
                >
                    {{ getScanStatusIcon(scan) }}
                </mat-icon>
                <div
                    class="einstallen-scan-row__ohrmarke"
                    [class.einstallen-scan-row__ohrmarke--clickable]="canReklamierenScan(scan)"
                    (click)="canReklamierenScan(scan) && reklamationFuerScanHinzufuegen(scan)"
                >
                    <span class="einstallen-scan-row__scan-types" aria-hidden="true">
                        <mat-icon
                            class="einstallen-scan-type-icon"
                            [class.einstallen-scan-type-icon--active]="hasOhrmarkeScanned(scan)"
                            matTooltip="Ohrmarke gescannt"
                        >label</mat-icon>
                        <mat-icon
                            class="einstallen-scan-type-icon"
                            [class.einstallen-scan-type-icon--active]="hasPassScanned(scan)"
                            matTooltip="Pass gescannt"
                        >badge</mat-icon>
                    </span>
                    <span
                        class="einstallen-scan-row__ohrmarke-last5"
                        [class.einstallen-scan-row__ohrmarke-last5--clickable]="canReklamierenScan(scan)"
                    >{{ getLastFiveDigits(scan.ohrmarke_notnull) }}</span>
                    <kiene-ohrmarke
                        class="einstallen-scan-row__ohrmarke-full"
                        [id]="'reklamation-on-click-' + i"
                        [ohrmarke]="scan.ohrmarke_notnull"
                    ></kiene-ohrmarke>
                </div>
                <div
                    *ngIf="!hideMobileHeader"
                    class="einstallen-scan-row__abteil"
                    [title]="getScanAbteilLabel(scan)"
                    data-cy="einstallen-scan-abteil"
                >
                    {{ getScanAbteilLabel(scan) }}
                </div>
                <div
                    *ngIf="!hideMobileHeader"
                    class="einstallen-scan-row__herkunft"
                    [title]="getScanHerkunftLabel(scan)"
                    data-cy="einstallen-scan-herkunft"
                >
                    {{ getScanHerkunftLabel(scan) }}
                </div>
                <div class="einstallen-scan-row__gewicht">
                    <span
                        *ngIf="scan?.success && scan?.einstallgewicht"
                        class="einstallen-scan-row__gewicht-pill"
                        [class.einstallen-scan-row__gewicht-pill--clickable]="canEditGewichtForScan(scan)"
                        (click)="canEditGewichtForScan(scan) && gewichtFuerScanBearbeiten(scan)"
                    >
                        <mat-icon *ngIf="canEditGewichtForScan(scan)" class="einstallen-scan-row__gewicht-edit-icon">edit</mat-icon>
                        <span>{{ scan.einstallgewicht }} kg</span>
                    </span>
                    <button
                        *ngIf="canEditGewichtForScan(scan) && !scan?.einstallgewicht"
                        mat-icon-button
                        class="einstallen-scan-row__gewicht-btn"
                        type="button"
                        data-cy="einstallen-scan-gewicht-setzen"
                        (click)="gewichtFuerScanBearbeiten(scan)"
                    >
                        <mat-icon color="accent">scale</mat-icon>
                    </button>
                    <span
                        *ngIf="!scan?.success || (!scan?.einstallgewicht && !canEditGewichtForScan(scan))"
                        class="einstallen-scan-row__gewicht-empty"
                    >—</span>
                </div>
                <div class="einstallen-scan-row__actions">
                    <button
                        *ngIf="canReklamierenScan(scan)"
                        mat-icon-button
                        color="accent"
                        type="button"
                        matTooltip="Reklamieren"
                        data-cy="einstallen-scan-reklamieren"
                        (click)="reklamationFuerScanHinzufuegen(scan); $event.stopPropagation()"
                    >
                        <mat-icon>feedback</mat-icon>
                    </button>
                    <button
                        *ngIf="scan?.success"
                        mat-icon-button
                        color="warn"
                        type="button"
                        matTooltip="Löschen"
                        (click)="scanLoeschen(scan); $event.stopPropagation()"
                    >
                        <mat-icon>delete</mat-icon>
                    </button>
                </div>
            </li>
        </ul>
    </div>
    </div>
</div>
